module.exports = __webpack_public_path__ + "static/img/pdf-details.5c01c94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/pdf-details.png
// module id = RpwI
// module chunks = 0